import { Button } from "flowbite-react";
import { motion } from "motion/react";

function ButtonComponent({
  children,
  onClick,
  type = "button",
  icon,
  className = "",
  color = "blue",
  size = "sm",
  disabled = false,
  iconPosition = "l",
  glow = true, // enable glowing effect by default
  ...rest
}) {
  return (
    <motion.div
      whileHover={
        !disabled
          ? {
              scale: 1.04,
              y: -1,
              boxShadow: glow ? "0px 0px 12px rgba(59,130,246,0.35)" : "none",
            }
          : {}
      }
      whileTap={!disabled ? { scale: 0.96 } : {}}
      transition={{ type: "spring", stiffness: 300, damping: 18 }}
      className="inline-block"
    >
      <Button
        {...rest}
        type={type}
        onClick={onClick}
        color={color}
        size={size}
        disabled={disabled}
        className={`
          ${className}
          flex items-center justify-center gap-2 px-4 py-2 font-semibold
          transition-all duration-300 ease-out
          !bg-app-button !text-app-button-text !border-app-button
          hover:!bg-app-button-hover
          disabled:opacity-60 disabled:cursor-not-allowed
          ${disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}
        `}
      >
        {icon && iconPosition == "l" && (
          <motion.span
            whileHover={!disabled ? { rotate: [0, -5, 5, 0] } : {}}
            transition={{ duration: 0.6 }}
            className="flex items-center"
          >
            {icon}
          </motion.span>
        )}
        {children && <span className="tracking-wide">{children}</span>}
        {icon && iconPosition == "r" && (
          <motion.span
            whileHover={!disabled ? { rotate: [0, -5, 5, 0] } : {}}
            transition={{ duration: 0.6 }}
            className="flex items-center"
          >
            {icon}
          </motion.span>
        )}
      </Button>
    </motion.div>
  );
}

export default ButtonComponent;
